export const CreditCardFormKeys = {
  name: true,
  number: true,
  cvc: true,
  exp_month: true,
  exp_year: true,
  address_line1: true,
  address_line2: true,
  address_city: true,
  address_state: true,
  address_zip: true
};
